import {createSelector} from '@reduxjs/toolkit';
import {RootState} from '../rootReducer';

export const getAvatarState = (state: RootState) => state.avatar;

export const getAvatarColors = createSelector(
  getAvatarState,
  ({avatarColors}) => avatarColors,
);
